// extracted by mini-css-extract-plugin
export var breadcrumbs = "ItemsPage-module--breadcrumbs--261e2";
export var character = "ItemsPage-module--character--7ecd3";
export var cyan = "ItemsPage-module--cyan--a9240";
export var header = "ItemsPage-module--header--4cf12";
export var heading = "ItemsPage-module--heading--a9e40";
export var left = "ItemsPage-module--left--00193";
export var noItemsMessage = "ItemsPage-module--noItemsMessage--8acaf";
export var paginationNav = "ItemsPage-module--paginationNav--f4524";
export var panel = "ItemsPage-module--panel--a28a0";
export var red = "ItemsPage-module--red--458dd";
export var right = "ItemsPage-module--right--cceae";
export var semiColon = "ItemsPage-module--semiColon--cca7b";
export var sep = "ItemsPage-module--sep--3572c";
export var spacer = "ItemsPage-module--spacer--92657";
export var squareBrackets = "ItemsPage-module--squareBrackets--21ee9";